import type { SpecsImageUploadValidationOptions } from "../specsImageUpload";
import {
  DEFAULT_SPECS_IMAGE_UPLOAD_ACCEPT,
  DEFAULT_SPECS_IMAGE_UPLOAD_VALIDATION,
} from "../specsImageUpload";
import type { SpecsFormFieldType, SpecsFormOption } from "../specsForm/types";

export type SpecsAutoFormImageUploadMetadata = {
  accept?: string;
  validation: SpecsImageUploadValidationOptions;
};

export type SpecsAutoFormFieldMetadata = {
  label: string;
  fieldType: SpecsFormFieldType;
  helperText?: string;
  placeholder?: string;
  minRows?: number;
  options?: SpecsFormOption[];
  allowNull?: boolean;
  debugPath?: string;
  imageUpload?: SpecsAutoFormImageUploadMetadata;
};

export type SpecsAutoFormFieldMetadataMap = Record<
  string,
  SpecsAutoFormFieldMetadata
>;

type ModelNodeWithMetadata = {
  constructor: {
    autoFormFields?: SpecsAutoFormFieldMetadataMap;
  };
  getAutoFormFieldMetadata?: (key: string) => SpecsAutoFormFieldMetadata | null;
};

export function getAutoFormFieldMetadata(
  node: unknown,
  key: string
): SpecsAutoFormFieldMetadata | null {
  if (!node || typeof node !== "object") {
    return null;
  }

  const modelNode = node as ModelNodeWithMetadata;
  const instanceMetadata = modelNode.getAutoFormFieldMetadata?.(key);
  if (instanceMetadata) {
    return instanceMetadata;
  }

  const metadata = modelNode.constructor.autoFormFields;
  return metadata?.[key] ?? null;
}

export function createImageUrlAutoFormField(
  metadata: Omit<SpecsAutoFormFieldMetadata, "fieldType">
): SpecsAutoFormFieldMetadata {
  return {
    ...metadata,
    fieldType: "imageUrl",
    imageUpload: {
      accept: metadata.imageUpload?.accept ?? DEFAULT_SPECS_IMAGE_UPLOAD_ACCEPT,
      validation: {
        ...DEFAULT_SPECS_IMAGE_UPLOAD_VALIDATION,
        ...metadata.imageUpload?.validation,
      },
    },
  };
}
